import { render, staticRenderFns } from "./ImportFeed.vue?vue&type=template&id=9d64e78e&scoped=true&"
import script from "./ImportFeed.vue?vue&type=script&lang=js&"
export * from "./ImportFeed.vue?vue&type=script&lang=js&"
import style0 from "./ImportFeed.vue?vue&type=style&index=0&id=9d64e78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d64e78e",
  null
  
)

export default component.exports